import API, { defaultHeaders } from '@/api';
import { USER_ROLES } from '@/api/user/index';

const fetchListing = (page = 1, type = USER_ROLES.ADMIN, query = null, pagination = true) => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;

  let url = `${API}/panel/users?page=${page}${query ? `&query=${query}` : ''}`;
  if (pagination === false) {
    url = `${API}/panel/users?pagination=0`;
  }

  url += `&type=${type}`;

  return fetch(url, { headers });
};

export default fetchListing;
